export {LoginInfoComponent} from './login-info'
export {UserModule} from './user.module'



// WEBPACK FOOTER //
// ./src/app/shared/user/index.ts